import { useState, useRef } from "react";
import PassportBuddyModal, { PASSPORT_GUIDE_SECTIONS } from "./Passportmodal.js";
import { ApplicationForm, TrackApplication } from "./Passportmodal.js";
import "./Passportguide.css";

export default function PassportGuide() {
  const [activeTab, setActiveTab] = useState("new");
  const [modalOpen, setModalOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [trackOpen, setTrackOpen] = useState(false);
  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="pg-root">

      {/* ── Sticky Nav ── */}
      {/*<nav className="pg-nav-bar">
        <span className="pg-nav-brand">TheVisaCo</span>
        <div className="pg-nav-actions">
          <button className="pg-btn-outline pg-btn-outline--dark pg-btn-sm" onClick={() => setTrackOpen(true)}>Track Application</button>
          <button className="pg-btn-primary pg-btn-sm" onClick={scrollToForm}>Apply Now</button>
        </div>
      </nav>*/}

      {/* ── Hero ── */}
      <section className="pg-hero" data-aos="fade-up">
        <div className="pg-hero-bg" />
        <div className="pg-hero-overlay" />
        <div className="pg-hero-inner">
          <div className="pg-hero-content">
            {/*<p className="pg-eyebrow">TheVisaCo — India's Trusted Passport Service</p>*/}
            <h1 className="pg-hero-heading">
              Your Passport,<br /><em>Our Responsibility</em>
            </h1>
            <p className="pg-hero-sub">
              We handle every step of your Indian passport journey — from form filling and document verification to real-time assistance at the passport center. You show up, we take care of the rest.
            </p>
            <div className="pg-hero-cta-row">
              <button className="pg-btn-primary pg-btn-primary--hero" onClick={scrollToForm}>
                Apply Now
              </button>
              <button className="pg-btn-outline" onClick={() => setModalOpen(true)}>
                Passport Buddy
              </button>
              <button className="pg-btn-outline" onClick={() => setDetailsOpen(true)}>
                Service Details
              </button>
              <button className="pg-btn-ghost" onClick={() => setTrackOpen(true)}>
                Track Application
              </button>
            </div>
          </div>

          {/*<div className="pg-hero-stats">
            <div className="pg-hero-stat">
              <span className="pg-hero-stat-num">10,000+</span>
              <span className="pg-hero-stat-label">Applications Processed</span>
            </div>
            <div className="pg-hero-stat">
              <span className="pg-hero-stat-num">24 hrs</span>
              <span className="pg-hero-stat-label">Response Guarantee</span>
            </div>
            <div className="pg-hero-stat">
              <span className="pg-hero-stat-num">98%</span>
              <span className="pg-hero-stat-label">First-Attempt Success</span>
            </div>
            <div className="pg-hero-stat">
              <span className="pg-hero-stat-num">50+</span>
              <span className="pg-hero-stat-label">Cities Covered</span>
            </div>
          </div>*/}
        </div>
      </section>

      {/* ── Passport Buddy Banner ── */}
      <section className="pg-buddy-banner" data-aos="fade-up">
        <div className="pg-container">
          <div className="pg-buddy-banner-inner">
            <div className="pg-buddy-text">
              <h3> Anxious about your passport center visit? </h3>
              <p>
                Our trained Passport Buddy will meet you at the Passport Office parking area and help you get fully prepared before your appointment. They can assist with checking your documents, arranging papers properly, and getting any required documents printed or photocopied for you on the spot. This optional add-on is designed to save time and help you enter the Passport Office with everything ready.
              </p>
            </div>
            {/* <button className="pg-btn-primary" onClick={scrollToForm}>
              Add Passport Buddy
            </button> */}
          </div>
        </div>
      </section>

      {/* ── Application Form ── */}
      <div ref={formRef} id="application-form" style={{ scrollMarginTop: "100px" }}>
        <ApplicationForm />
      </div>

      {/* ── How We Work ── */}
      <section className="pg-section" data-aos="fade-up">
        <div className="pg-container">
          <div className="pg-section-header">
            {/* <p className="pg-label">Our Process</p> */}
            <h2 className="pg-section-title">How TheVisaCo Works For You</h2>
            <p className="pg-body">
              We have simplified India's passport process into a seamless, end-to-end service. Here is exactly what happens after you apply with us.
            </p>
          </div>
          <div className="pg-process-steps">
            {[
              { num: "01", title: "Fill Our Application", desc: "Complete the online form on our platform. We review every detail — name, address, ID numbers — before submission so nothing is missed or incorrect." },
              { num: "02", title: "Document Verification", desc: "Upload your Aadhaar, PAN, and passport documents. Our team verifies authenticity, checks consistency, and prepares a complete document package." },
              { num: "03", title: "Appointment Booking", desc: "We log into the Passport Seva portal on your behalf and secure the earliest available slot at the nearest PSK or POPSK to you." },
              { num: "04", title: "Official Form Filing", desc: "Our experts fill the official government form accurately and submit it to the Passport Seva portal. You receive a confirmed application number." },
              { num: "05", title: "Center Assistance", desc: "Avail Passport Buddy and our agent meets you at the center — guides you through every counter, manages your documents, and ensures smooth verification." },
              { num: "06", title: "Passport Dispatch", desc: "After biometric capture and police verification, your passport is printed and dispatched to your address via Speed Post. We keep you updated." },
            ].map((step, i) => (
              <div className="pg-process-step" key={step.num} data-aos="fade-up" data-aos-delay={i * 100}>
                <span className="pg-step-num">{step.num}</span>
                <h4 className="pg-step-title">{step.title}</h4>
                <p className="pg-step-desc">{step.desc}</p>
              </div>
            ))}
          </div>
          <div className="pg-apply-cta--row">
            <button className="pg-btn-primary pg-btn-lg" onClick={scrollToForm}>
              Start Your Application
            </button>
            <button className="pg-btn-outline pg-btn-outline--dark pg-btn-lg" onClick={() => setModalOpen(true)}>
              Add Passport Buddy
            </button>
          </div>
        </div>
      </section>

      {/* ── Tabs Section ── */}
      <section className="pg-tabs-section pg-section--alt" data-aos="fade-up">
        <div className="pg-container">
          <div className="pg-section-header">
            {/* <p className="pg-label">Services</p> */}
            <h2 className="pg-section-title">Passport Services We Handle</h2>
          </div>
          <div className="pg-tabs-wrap">
            <button className="pg-tabs-arrow pg-tabs-arrow--left" onClick={(e) => { const el = e.currentTarget.parentElement.querySelector('.pg-tabs'); el.scrollBy({ left: -200, behavior: 'smooth' }); }} aria-label="Scroll left">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <div className="pg-tabs">
              {PASSPORT_GUIDE_SECTIONS.map((s) => (
                <button
                  key={s.id}
                  className={`pg-tab ${activeTab === s.id ? "pg-tab--active" : ""}`}
                  onClick={() => setActiveTab(s.id)}
                >
                  {s.label}
                </button>
              ))}
            </div>
            <button className="pg-tabs-arrow pg-tabs-arrow--right" onClick={(e) => { const el = e.currentTarget.parentElement.querySelector('.pg-tabs'); el.scrollBy({ left: 200, behavior: 'smooth' }); }} aria-label="Scroll right">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
          </div>
          <div className="pg-tab-content">
            {activeTab === "new" && <NewPassportSection onApply={scrollToForm} />}
            {activeTab === "renewal" && <RenewalSection onApply={scrollToForm} />}
            {activeTab === "reissue" && <ReissueSection onApply={scrollToForm} />}
            {activeTab === "tatkaal" && <TatkaalSection onApply={scrollToForm} />}
          </div>
        </div>
      </section>

      {/* ── Documents ── */}
      <section className="pg-section" data-aos="fade-up">
        <div className="pg-container">
          <div className="pg-section-header">
            {/* <p className="pg-label">Document Management</p> */}
            <h2 className="pg-section-title">We Handle Your Document Checklist</h2>
            <p className="pg-body">
              Our team cross-checks every document before submission. Here is what we will need from you — and we will tell you exactly how to prepare each one.
            </p>
          </div>
          <div className="pg-docs-grid">
            {[
              { title: "Adults", items: ["Address proof (utility bill, Aadhaar, voter ID)", "Date of birth proof (birth certificate, school certificate)", "Valid identity proof (Aadhaar, PAN card, voter ID)", "Recent passport-size photographs", "Old passport (for reissue applications)"] },
              { title: "Minors (Below 18)", items: ["Original birth certificate", "Parent or guardian's passport copy", "Annexure declarations signed by both parents", "School identity card or bonafide certificate", "Aadhaar card of the minor (if available)"] },
              { title: "Annexures We Prepare (A–M)", items: ["Annexure A — Government employees", "Annexure C — Minors (single parent)", "Annexure D — Name change declaration", "Annexure G — Prior/pending criminal cases", "Annexure I — Address verification by employer"] },
            ].map((doc, i) => (
              <div className="pg-doc-card" key={doc.title} data-aos="fade-up" data-aos-delay={i * 100}>
                <h3 className="pg-doc-card-title">{doc.title}</h3>
                <ul className="pg-doc-list">
                  {doc.items.map((item) => <li key={item}>{item}</li>)}
                </ul>
              </div>
            ))}
          </div>
          <p className="pg-docs-note">
            Our team always cross-checks every document for consistency before your appointment — eliminating the most common reason for delays and rejections.
          </p>
          <div className="pg-apply-cta--row">
            <button className="pg-btn-primary" onClick={scrollToForm}>
              Upload Documents &amp; Apply
            </button>
            <button className="pg-btn-outline pg-btn-outline--dark" onClick={() => setDetailsOpen(true)}>
              View Service Details
            </button>
          </div>
        </div>
      </section>

      {/* ── Police Verification ── */}
      <section className="pg-section pg-section--alt" data-aos="fade-up">
        <div className="pg-container">
          <div className="pg-two-col">
            <div className="pg-two-col-text">
              {/* <p className="pg-label">Verification Support</p> */}
              <h2 className="pg-section-title">We Guide You Through Police Verification</h2>
              <p className="pg-body">
                Police verification is a critical step that often causes delays. TheVisaCo prepares you in advance — ensuring your address details match across all documents and you are ready when the officer visits.
              </p>
              <div className="pg-verify-pills">
                <div className="pg-verify-pill">
                  <span className="pg-pill-label">Pre-Verification</span>
                  <p className="pg-pill-desc">We prepare all address proofs for consistency so verification clears the first time.</p>
                </div>
                <div className="pg-verify-pill">
                  <span className="pg-pill-label">Post-Verification (Tatkaal)</span>
                  <p className="pg-pill-desc">We brief you on what to expect and keep you informed at every stage of follow-up.</p>
                </div>
              </div>
              <div className="pg-apply-cta--row" style={{ marginTop: "clamp(24px, 3vw, 40px)" }}>
                <button className="pg-btn-primary" onClick={scrollToForm}>Apply Now</button>
              </div>
            </div>
            <div className="pg-two-col-side">
              <div className="pg-info-box">
                <h4 className="pg-info-box-title">We Prevent These Common Delays</h4>
                <ul className="pg-info-list">
                  <li>Address mismatch in documents</li>
                  <li>Applicant absent during police visit</li>
                  <li>Neighbour or local verification failure</li>
                  <li>Incorrect PIN code or landmark</li>
                  <li>Pending dues or criminal records</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Lost / Damaged ── */}
      <section className="pg-section" data-aos="fade-up">
        <div className="pg-container">
          <div className="pg-section-header">
            {/* <p className="pg-label">Emergency Service</p> */}
            <h2 className="pg-section-title">Lost or Damaged Passport — We Take Over</h2>
            <p className="pg-body">
              Losing a passport is stressful. Our team guides you through every step, files the necessary declarations, and gets your new passport in motion fast.
            </p>
          </div>
          <div className="pg-steps-row">
            {[
              { num: "01", title: "FIR Guidance", desc: "We guide you on how to file an FIR at the nearest police station and what to request in the report for a smooth reissue process." },
              { num: "02", title: "Reissue Application", desc: "Our team handles the reissue application under the Lost Passport category, filling every form field with the correct details." },
              { num: "03", title: "Declaration Preparation", desc: "We prepare the affidavit, FIR copy submission, and all supporting declarations required by the passport authority." },
              { num: "04", title: "Center Appointment", desc: "We book your PSK appointment and can send a Passport Buddy to accompany you for biometric capture and document verification." },
            ].map((step, i) => (
              <div className="pg-step" key={step.num} data-aos="fade-up" data-aos-delay={i * 100}>
                <span className="pg-step-num">{step.num}</span>
                <h4 className="pg-step-title">{step.title}</h4>
                <p className="pg-step-desc">{step.desc}</p>
              </div>
            ))}
          </div>
          <div className="pg-apply-cta--row">
            <button className="pg-btn-primary" onClick={scrollToForm}>
              Apply for Lost / Damaged Passport
            </button>
            <button className="pg-btn-outline pg-btn-outline--dark" onClick={() => setModalOpen(true)}>
              Add Passport Buddy
            </button>
          </div>
        </div>
      </section>

      {/* ── Updates ── */}
      <section className="pg-section pg-section--alt" data-aos="fade-up">
        <div className="pg-container">
          <div className="pg-section-header">
            {/* <p className="pg-label">Updates &amp; Modifications</p> */}
            <h2 className="pg-section-title">Name and Address Updates — Handled by Us</h2>
          </div>
          <div className="pg-update-grid">
            {[
              { title: "Name Change", desc: "After marriage, legal correction, or spelling errors — we prepare the marriage certificate or gazette notification submission on your behalf." },
              { title: "Address Change", desc: "We compile the updated address proof — Aadhaar, utility bill, or bank statement — and ensure it matches your application perfectly." },
              { title: "DigiLocker Integration", desc: "We guide you on linking DigiLocker so verified digital copies of Aadhaar, PAN, and certificates are accepted at the PSK without physical submission." },
              { title: "Status Tracking", desc: "Use your unique Track ID to monitor your application status in real time — appointment dates, filing confirmations, and dispatch updates — all in one place." },
            ].map((item, i) => (
              <div className="pg-update-card" key={item.title} data-aos="fade-up" data-aos-delay={i * 100}>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
          <div className="pg-apply-cta--row">
            <button className="pg-btn-primary" onClick={scrollToForm}>Apply Now</button>
            <button className="pg-btn-outline pg-btn-outline--dark" onClick={() => setTrackOpen(true)}>Track Your Application</button>
          </div>
        </div>
      </section>

      {/* ── Additional Services ── */}
      <section className="pg-section" data-aos="fade-up">
        <div className="pg-container">
          <div className="pg-section-header">
            {/* <p className="pg-label">Know More</p> */}
            <h2 className="pg-section-title">Services We Cover</h2>
          </div>
          <div className="pg-modules-grid">
            {[
              { title: "New Indian Passport", desc: "Complete end-to-end handling for first-time applicants — form filling, document preparation, fee payment, and appointment booking." },
              { title: "ECR / Non-ECR Passport", desc: "We assess your ECR status and ensure the correct category is marked on your application to avoid travel complications." },
              { title: "Rejection Prevention", desc: "Our pre-submission review catches mismatched documents, failed verification risks, and other frequent causes of rejection before they happen." },
              { title: "PSK Appointment Booking", desc: "We secure the earliest available appointment at the nearest Passport Seva Kendra or Post Office Passport Seva Kendra for you." },
            ].map((mod, i) => (
              <div className="pg-module-card" key={mod.title} data-aos="fade-up" data-aos-delay={i * 100}>
                <h4 className="pg-module-title">{mod.title}</h4>
                <p className="pg-module-desc">{mod.desc}</p>
                <button className="pg-module-link-btn" onClick={scrollToForm}>Apply Now</button>
              </div>
            ))}
          </div>
          <div className="pg-apply-cta--row">
            <button className="pg-btn-primary pg-btn-lg" onClick={scrollToForm}>Start Your Application</button>
            <button className="pg-btn-outline pg-btn-outline--dark pg-btn-lg" onClick={() => setDetailsOpen(true)}>View All Services &amp; Pricing</button>
          </div>
        </div>
      </section>

      {/* ── Why Choose Us ── */}
      <section className="pg-section pg-help-section pg-section--alt" data-aos="fade-up">
        <div className="pg-container">
          <div style={{ maxWidth: "800px" }}>
            {/* <p className="pg-label">Why Choose Us</p> */}
            <h2 className="pg-section-title">What TheVisaCo Does For You</h2>
            <p className="pg-body">
              Navigating India's passport system is complicated — wrong entries, missed documents, or incorrect fee payments can set you back weeks. We handle every detail so your passport arrives without delays.
            </p>
            <ul className="pg-help-list">
              <li>Complete form filling for new applications, renewals, and reissues</li>
              <li>Document checklist review and pre-submission verification</li>
              <li>Tatkaal eligibility assessment and fast-track application handling</li>
              <li>Police verification preparation and timeline guidance</li>
              <li>Dedicated callback support within 24 hours</li>
              <li>Passport Buddy — our agent physically with you at the passport center</li>
            </ul>
            <div className="pg-help-cta-row">
              <button className="pg-btn-primary pg-btn-lg" onClick={scrollToForm}>
                Apply Now
              </button>
              <button className="pg-btn-outline pg-btn-outline--dark pg-btn-lg" onClick={() => setModalOpen(true)}>
                Get Passport Buddy
              </button>
              <button className="pg-btn-outline pg-btn-outline--dark pg-btn-lg" onClick={() => setTrackOpen(true)}>
                Track Application
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      {/*}
      <footer className="pg-footer">
        <div className="pg-container pg-footer-inner">
          <div className="pg-footer-top">
            <div>
              <p className="pg-footer-brand">TheVisaCo</p>
              <p className="pg-footer-tagline">India's Trusted Passport Assistance Service</p>
            </div>
            <button className="pg-btn-primary" onClick={scrollToForm}>Apply Now</button>
          </div>
          <p className="pg-footer-disclaimer">
            TheVisaCo is an independent passport assistance and facilitation service. We are not affiliated with the Government of India or the Ministry of External Affairs. Government fees are separate from our service charges and are paid directly to the official portal. All official passport applications are submitted to passportindia.gov.in.
          </p>
        </div>
      </footer>*/}

      {/* ── Modals ── */}
      {modalOpen && <PassportBuddyModal onClose={() => setModalOpen(false)} onApply={scrollToForm} />}
      {detailsOpen && <ServiceDetailsModal onClose={() => setDetailsOpen(false)} onApply={scrollToForm} />}
      {trackOpen && <TrackApplication onClose={() => setTrackOpen(false)} />}
    </div>
  );
}

/* ── Tab Sections ── */
function NewPassportSection({ onApply }) {
  return (
    <div className="pg-content-block">
      <h3 className="pg-content-title">Applying for a New Indian Passport — We Do It For You</h3>
      <p className="pg-body">
        First-time passport applicants face the most complex process. TheVisaCo manages every step — from registering on the portal to ensuring your documents are accepted the first time.
      </p>
      <div className="pg-numbered-steps">
        {[
          "We register your application on the Passport Seva portal with all correct personal details.",
          "Our team fills the online application form on your behalf — accurately and completely.",
          "We assess your travel urgency and select the right service type: Normal or Tatkaal.",
          "We guide you through the government fee payment and confirm the transaction.",
          "We book your appointment at the nearest PSK or POPSK at the earliest available slot.",
          "We prepare a complete document kit — checklist verified, copies organised, originals listed.",
          "You visit the center; optionally with a Passport Buddy agent from our team.",
          "We brief you on biometric capture and ensure you are prepared for the visit.",
        ].map((step, i) => (
          <div className="pg-nstep" key={i}>
            <span className="pg-nstep-num">{String(i + 1).padStart(2, "0")}</span>
            <p>{step}</p>
          </div>
        ))}
      </div>
      <div className="pg-apply-cta--row">
        <button className="pg-btn-primary" onClick={onApply}>Apply for New Passport</button>
      </div>
    </div>
  );
}

function RenewalSection({ onApply }) {
  return (
    <div className="pg-content-block">
      <h3 className="pg-content-title">Passport Renewal — Handled End-to-End by TheVisaCo</h3>
      <p className="pg-body">
        Passport renewal involves a Reissue application — and a single wrong entry can delay you by weeks. Our team handles the entire process so your renewal is seamless.
      </p>
      <div className="pg-two-list">
        <div>
          <h4 className="pg-subhead">When We Help You Renew</h4>
          <ul className="pg-doc-list">
            <li>Passport has expired or expires within 12 months</li>
            <li>All visa pages have been used</li>
            <li>Passport is physically damaged</li>
            <li>Address or name needs to be updated</li>
          </ul>
        </div>
        <div>
          <h4 className="pg-subhead">How We Handle Your Renewal</h4>
          <ul className="pg-doc-list">
            <li>We log into the Passport Seva portal on your behalf</li>
            <li>We select the correct Reissue category for your case</li>
            <li>We update all required personal information accurately</li>
            <li>We facilitate the applicable government fee payment</li>
            <li>We book and brief you for your PSK appointment</li>
          </ul>
        </div>
      </div>
      <p className="pg-body-sm">
        Processing time depends on service type selected and whether police verification is mandatory. We assess this upfront and set the right expectations.
      </p>
      <div className="pg-apply-cta--row">
        <button className="pg-btn-primary" onClick={onApply}>Renew My Passport</button>
      </div>
    </div>
  );
}

function ReissueSection({ onApply }) {
  return (
    <div className="pg-content-block">
      <h3 className="pg-content-title">Reissue of Passport — Our Team Takes Over</h3>
      <p className="pg-body">
        Whether your passport is lost, stolen, damaged, or expired — TheVisaCo handles the reissue process with urgency and precision.
      </p>
      <div className="pg-reissue-grid">
        <div className="pg-reissue-item">
          <h4>Lost Passport</h4>
          <p>We guide you on filing an FIR and immediately handle the reissue application under the Lost category with the correct documentation and notarised affidavit.</p>
        </div>
        <div className="pg-reissue-item">
          <h4>Damaged Passport</h4>
          <p>We assess the extent of damage, submit the damaged passport correctly, and handle whether police verification will be triggered — so you are never caught off guard.</p>
        </div>
        <div className="pg-reissue-item">
          <h4>Expired Passport</h4>
          <p>We process the standard reissue — compiling your old passport, updated documents, and booking your PSK or POPSK appointment efficiently.</p>
        </div>
        <div className="pg-reissue-item">
          <h4>Exhausted Pages</h4>
          <p>Frequent travellers get priority — we apply for a 60-page booklet reissue and ensure the process is completed before your next trip is affected.</p>
        </div>
      </div>
      <div className="pg-apply-cta--row">
        <button className="pg-btn-primary" onClick={onApply}>Apply for Reissue</button>
      </div>
    </div>
  );
}

function TatkaalSection({ onApply }) {
  return (
    <div className="pg-content-block">
      <h3 className="pg-content-title">Tatkaal vs Normal Processing — We Guide You to the Right Choice</h3>
      <p className="pg-body">
        Choosing the wrong processing track costs you time and money. Our team assesses your urgency, eligibility, and documents to recommend the correct option.
      </p>
      <div className="pg-compare-table">
        <div className="pg-compare-header">
          <div className="pg-compare-col-label"></div>
          <div className="pg-compare-col">Normal</div>
          <div className="pg-compare-col">Tatkaal</div>
        </div>
        {[
          { label: "Processing Time", normal: "2 to 4 weeks", tatkaal: "1 to 3 working days" },
          { label: "Fee (36 pages)", normal: "Rs. 1,500 (Govt.)", tatkaal: "Rs. 3,500 (Govt.)" },
          { label: "Fee (60 pages)", normal: "Rs. 2,000 (Govt.)", tatkaal: "Rs. 4,000 (Govt.)" },
          { label: "Police Verification", normal: "Before issuance", tatkaal: "Often after issuance" },
          { label: "Additional Documents", normal: "Standard set", tatkaal: "Extra supporting docs needed" },
          { label: "Best For", normal: "Planned travel with ample time", tatkaal: "Urgent and last-minute travel" },
        ].map((row) => (
          <div className="pg-compare-row" key={row.label}>
            <div className="pg-compare-col-label">{row.label}</div>
            <div className="pg-compare-col">{row.normal}</div>
            <div className="pg-compare-col">{row.tatkaal}</div>
          </div>
        ))}
      </div>
      <p className="pg-body-sm">
        Official government fee structure: Normal — Rs. 1,500 (36 pages), Rs. 2,000 (60 pages). Tatkaal — Rs. 3,500 (36 pages), Rs. 4,000 (60 pages). Our service fee is charged separately and shown in the application form.
      </p>
      <div className="pg-apply-cta--row">
        <button className="pg-btn-primary" onClick={onApply}>Choose Your Service</button>
      </div>
    </div>
  );
}

/* ── Service Details Modal ── */
function ServiceDetailsModal({ onClose, onApply }) {
  return (
    <div className="pb-overlay" onClick={onClose}>
      <div className="pb-modal pb-modal--wide" onClick={(e) => e.stopPropagation()}>
        <div className="pb-modal-header">
          <div>
            <h2 className="pb-modal-title">Our Services &amp; Pricing</h2>
            <p className="pb-modal-sub">Everything TheVisaCo offers — transparent pricing, no hidden fees.</p>
          </div>
           <button className="pb-close" onClick={onClose}>&times;</button>
        </div>
        <div className="pb-modal-body">
          <div className="sd-section">
            <h3 className="sd-heading">Service 1 — Passport Application Assistance</h3>
            <p className="sd-desc">
              We handle your complete passport application — form filling, document verification, government portal submission, and appointment booking.
            </p>
            <div className="sd-grid">
              {[
                { service: "New Passport (Normal)", fee: "Rs. 1,500 (Govt.)", our: "Rs. 999 (Service)" },
                { service: "New Passport (Tatkaal)", fee: "Rs. 3,500 (Govt.)", our: "Rs. 1,499 (Service)" },
                { service: "Renewal / Reissue (Normal)", fee: "Rs. 1,500 (Govt.)", our: "Rs. 999 (Service)" },
                { service: "Renewal / Reissue (Tatkaal)", fee: "Rs. 3,500 (Govt.)", our: "Rs. 1,499 (Service)" },
                { service: "60-Page Booklet (Normal)", fee: "Rs. 2,000 (Govt.)", our: "Rs. 1,199 (Service)" },
                { service: "60-Page Booklet (Tatkaal)", fee: "Rs. 4,000 (Govt.)", our: "Rs. 1,799 (Service)" },
              ].map((row) => (
                <div className="sd-row" key={row.service}>
                  <span className="sd-service">{row.service}</span>
                  <span className="sd-fee">{row.fee}</span>
                  <span className="sd-our">{row.our}</span>
                </div>
              ))}
            </div>
            <p className="sd-note">GST of 18% is applicable on service fees. Government fees are paid separately during appointment confirmation.</p>
          </div>

          <div className="sd-section">
            <h3 className="sd-heading">Service 2 — Passport Buddy (Real-Time Center Assistance)</h3>
            <p className="sd-desc">
              Our trained agent physically accompanies you to the passport center — guiding you through every counter, queue, and document check. Optional add-on per person.
            </p>
            <div className="sd-grid">
              {[
                { service: "Passport Buddy — 1 Person", fee: "Rs. 1,999 per visit" },
                { service: "Passport Buddy — 2 Persons", fee: "Rs. 3,499 per visit" },
                { service: "Passport Buddy — 3+ Persons", fee: "Rs. 1,499 per additional person" },
              ].map((row) => (
                <div className="sd-row sd-row--buddy" key={row.service}>
                  <span className="sd-service">{row.service}</span>
                  <span className="sd-our">{row.fee}</span>
                </div>
              ))}
            </div>
            <p className="sd-note">Available in select cities. Confirm availability in the application form. GST of 18% applicable.</p>
          </div>

          <div className="sd-section">
            <h3 className="sd-heading">Re-Application (Missed Appointment)</h3>
            <p className="sd-desc">
              If you miss your appointment or need to reschedule, we handle the re-application. Charges are per person re-applying.
            </p>
            <div className="sd-grid">
              {[
                { service: "Re-application Filing Fee", fee: "Rs. 499 per person" },
                { service: "Re-application + Buddy", fee: "Rs. 499 + Buddy fee" },
              ].map((row) => (
                <div className="sd-row" key={row.service}>
                  <span className="sd-service">{row.service}</span>
                  <span className="sd-our">{row.fee}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="sd-section">
            <h3 className="sd-heading">Payment Modes &amp; Convenience Fees</h3>
            <div className="sd-grid">
              {[
                { service: "UPI (GPay, PhonePe, Paytm)", fee: "No convenience fee" },
                { service: "Net Banking", fee: "Rs. 15 convenience fee" },
                { service: "Credit / Debit Card", fee: "Rs. 25 + 1.5% of amount" },
              ].map((row) => (
                <div className="sd-row" key={row.service}>
                  <span className="sd-service">{row.service}</span>
                  <span className="sd-our">{row.fee}</span>
                </div>
              ))}
            </div>
            <p className="sd-note">All fees shown are exclusive of GST (18%). Final amount with GST and convenience fee is shown at checkout.</p>
          </div>
        </div>
        <div className="pb-modal-footer">
          <p className="pb-footer-note">Prices shown are our service charges. Government fees are additional.</p>
          <div className="pb-footer-actions">
            <button className="pb-cancel-btn" onClick={onClose}>Close</button>
            <button className="pb-submit-btn" onClick={() => { onClose(); onApply(); }}>Apply Now</button>
          </div>
        </div>
      </div>
    </div>
  );
}